import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportesPagosService {

  private service_url: string = '';
  constructor(
    private constantsService: ConstantsService,
    private http: Http,
    private authService: AutenticacionService
  ) {
    this.service_url = this.constantsService.apiURL + '/reportes/pagos';
  }

  public general(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.fechaInicio) {
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if (filters.fechaFin) {
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if (filters.tipoCredito) {
      myParams.append('tipo_credito', filters.tipoCredito);
    }

    if (filters.sucursal) {
      myParams.append('sucursal', filters.sucursal);
    }

    // 🔹 NUEVO
    if (filters.incluirMorosos) {
      myParams.append('incluir_morosos', '1');
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    let serviceUrl = this.service_url + '/general';

    return this.http.get(serviceUrl, myoptions);
  }

  public exportToExcel(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.fechaInicio) {
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if (filters.fechaFin) {
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if (filters.tipoCredito) {
      myParams.append('tipo_credito', filters.tipoCredito);
    }

    if (filters.sucursal) {
      myParams.append('sucursal', filters.sucursal);
    }
    // 🔹 NUEVO
    if (filters.incluirMorosos) {
      myParams.append('incluir_morosos', '1');
    }
    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.service_url + '/general/export';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }

    public avancesgeneral(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.fechaInicio) {
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if (filters.fechaFin) {
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if (filters.tipoCredito) {
      myParams.append('tipo_credito', filters.tipoCredito);
    }

    if (filters.sucursal) {
      myParams.append('sucursal', filters.sucursal);
    }

    // 🔹 NUEVO
    if (filters.incluirMorosos) {
      myParams.append('incluir_morosos', '1');
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    let serviceUrl = this.service_url + '/avancesgeneral';

    return this.http.get(serviceUrl, myoptions);
  }

  public exportAvancesToExcel(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.fechaInicio) {
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if (filters.fechaFin) {
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if (filters.tipoCredito) {
      myParams.append('tipo_credito', filters.tipoCredito);
    }

    if (filters.sucursal) {
      myParams.append('sucursal', filters.sucursal);
    }
    // 🔹 NUEVO
    if (filters.incluirMorosos) {
      myParams.append('incluir_morosos', '1');
    }
    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.service_url + '/avancesgeneral/export';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }

  public getReportePenalizaciones(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.tipoCredito) {
      myParams.append('tipo_credito', filters.tipoCredito);
    }

    if (filters.sucursal) {
      myParams.append('sucursal', filters.sucursal);
    }

    if (filters.fechaInicio) {
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if (filters.fechaFin) {
      myParams.append('fecha-fin', filters.fechaFin);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    let serviceUrl = this.service_url + '/penalizaciones';

    return this.http.get(serviceUrl, myoptions);
  }

  public exportPenalizacionesToExcel(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.fechaInicio) {
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if (filters.fechaFin) {
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if (filters.tipoCredito) {
      myParams.append('tipo_credito', filters.tipoCredito);
    }

    if (filters.sucursal) {
      myParams.append('sucursal', filters.sucursal);
    }
    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.service_url + '/penalizaciones/export';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/reportes/reportes-pagos.service.ts